import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { EntitiesServiceService } from '../../../../../services/entities-service.service';

@Component({
  selector: 'app-dmk-common',
  templateUrl: './dmk-common.component.html',
  styleUrls: ['./dmk-common.component.css']
})
export class DmkCommonComponent implements OnInit, OnDestroy {
  @Input() entityDetails: any;
  @Input() widgetData: any;
  @Input() entityId: string;
  isloader: boolean = true;
  isError: boolean = false;
  masterAttData: any = {};
  clutchPadRul: any = [];

  private _intervalTimer: any;
  private _entityAttributeValueSubscription: Subscription;
  
  constructor(private _service: EntitiesServiceService, private _sharedService: ServicecallService) { }

  ngOnInit(): void {
    this._fetchAttDetails();
  }
  infoHoverLabel() {
    const profileConfig = this._sharedService.getConfigurationBasedOnCategory(this.entityDetails) ?
      this._sharedService.getConfigurationBasedOnCategory(this.entityDetails) : [];
    const range = profileConfig?.widgetGaugeRange?.[this.widgetData?.widgetDataAttributes?.attributeName ?? this.widgetData?.entityType];
    return '\nCurrent Value: ' + this.masterAttData?.value?.toString() + '\nOptimal Range: ' +
      this.masterAttData?.thresholdLow?.toString() + ' to ' + this.masterAttData?.thresholdHigh?.toString() +
      '\nRange: ' + (range?.length ? range?.[0]?.toString() : '') + ' to ' + (range?.length ? range?.[1]?.toString() : '');
  }
  
  ngOnDestroy(): void {
    this._entityAttributeValueSubscription?.unsubscribe();
    this._clearTimer();
  }
  private _fetchAttDetails() {
    const payload = {
      attributes: [this.widgetData?.widgetDataAttributes?.attributeName ?? this.widgetData?.entityType],
      entityId: this.entityId
    }
    this._entityAttributeValueSubscription = this._service.entityAttributeValue(payload).subscribe(
      {
        next: (result: any) => {
          this.masterAttData = result?.length ? result[0] : [];
          this.isloader = false;
          this._setGaugeData();
        },
        error: (error) => {
          if (error) {
            this.isloader = false;
            this.isError = true;
            this.masterAttData.value = 0;
            this._setGaugeData();
          }
        }
      }
    )
  }

  private _setGaugeData() {
    const profileConfig = this._sharedService.getConfigurationBasedOnCategory(this.entityDetails) ?
      this._sharedService.getConfigurationBasedOnCategory(this.entityDetails) : [];
    const range = profileConfig?.widgetGaugeRange?.[this.widgetData?.widgetDataAttributes?.attributeName ?? this.widgetData?.entityType];
    this.clutchPadRul = [[
      {
        type: "indicator",
        mode: "gauge+number",
        value: this.masterAttData?.value ? this.masterAttData?.value : 0,
        gauge: {
          axis: { range: range ? range : [null, null], showticklabels: false, ticks: "" },
          bar: { color: "#055C7B", thickness: .3 },
          steps: [
            { range: [this.masterAttData?.thresholdLow, this.masterAttData?.thresholdHigh], color: "#2EDB96", thickness: .5 },
            { range: [range ? range[0] : null, this.masterAttData?.thresholdLow], color: "#F2F4F3", thickness: .3 },
            { range: [this.masterAttData?.value, range ? range[1] : null], color: "#F2F4F3", thickness: .3 }
          ],
          bordercolor: "transparent",
        },
        height: 200,
        annotation: [
          {
            text: '',
            showarrow: false,
            y: .6,
            font: {
              family: "Inter",
              size: 18,
              color: "#615E83"
            },
          }
        ]
      }
    ]];
    this._refreshApi();
  }
  private _refreshApi() {
    if (+this.widgetData?.refreshRate) {
      this._clearTimer();
      this._intervalTimer = setInterval(() => {
        this._fetchAttDetails();
      }, +this.widgetData?.refreshRate);
      this.isError = false;
    }
  }

  private _clearTimer() {
    if (this._intervalTimer) {
      clearInterval(this._intervalTimer);
    }
  }

}
